/* eslint-disable */

import React from 'react'
import Select, { components } from 'react-select'
import styled from 'styled-components'
import { colors } from 'utils'
import CheckboxInSelect from '../CheckboxInSelect'
import Icon from '../Icon'

const DropdownIcon = styled(Icon)`
    margin-left: -5px;
    margin-right: 2px;
    display: flex;
    align-items: center;
`

const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
        <DropdownIcon icon="menuDown" color="#474A4C" size={18} />
    </components.DropdownIndicator>
)

export interface FilterProps {
    defaultValue?: any
    onChange: (input?: any) => void
    isMulti?: boolean
    isClearable?: boolean
    options: Record<any, any>[]
    optionValue?: string,
    optionLabel?: string,
    className?: string,
    placeholder?: string,
}

const Filter = ({
    defaultValue,
    onChange,
    isMulti,
    isClearable,
    options,
    optionValue = 'value',
    optionLabel = 'label',
    className,
    placeholder = 'Select...'
}: FilterProps) => {
    const customStyles = {
        control: (provided) => ({
            ...provided,
            height: 44,
            borderColor: colors.inputBorder,
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            height: 12,
            margin: 'auto',
            background: colors.inputBorder
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: 14,
            color: colors.grayTitle,
        }),
        option: (provided) => ({
            ...provided,
            fontSize: 14,
            backgroundColor: isMulti ? 'white !important' : provided.backgroundColor,
            color: isMulti ? `${colors.icon} !important` : provided.color,
        }),
        placeholder: (provided) => ({
            ...provided,
            fontWeight: 400,
            fontSize: '14px',
            color: colors.grayTitle,
        }),
        valueContainer: (provided) => ({
            ...provided,
            maxHeight: 42,
        })
    }

    const Option = (props) => (
        <div>
            <components.Option {...props}>
                <CheckboxInSelect label={props.label} checked={props.isSelected} />
            </components.Option>
        </div>
    )
    let _components = {DropdownIndicator}
    if (isMulti) {
        // @ts-ignore
        _components = {..._components, Option}
    }

    return (
        <Select
            defaultValue={defaultValue}
            options={options}
            onChange={onChange}
            styles={customStyles}
            isMulti={isMulti}
            isClearable={isClearable}
            getOptionValue={(option) => option[optionValue]}
            getOptionLabel={(option) => option[optionLabel]}
            components={_components}
            className={className}
            closeMenuOnSelect={!isMulti}
            hideSelectedOptions={false}
            blurInputOnSelect={!isMulti}
            controlShouldRenderValue={!isMulti}
            placeholder={placeholder}
            isSearchable={!isMulti}
        />
    )
}

export default Filter
